<div class="wrapper">
   <main>
      @if (errorMessage) {
         <header class="navbar">
            <div class="container s_con">
               <div id="s_navleft" class="s_sys-notice">
                  <div class="s_con-title">Safari SOP Update Error</div>
                  <hr>
                  <div class="text-danger">
                     <br>
                     <p>
                        Failed to update the application. This can be caused by a network error, VPN or proxy settings, or ad-blockers and browser extensions. <br>
                     </p>
                     <p>
                        If the error keeps occuring please contact your IT department to verify that the <b>safarisop.com</b> domain is added to the list of safe domains.
                     </p>
                     <p>
                        In the meanwhile you can temporarily bypass this error by pressing CTRL and F5 at the same time (Windows) or CMD, Shift and R (Mac).
                     </p>
                  </div>
                  <hr>
               </div>
            </div>
         </header>
      } @else {
         <div class="s_update-scene">
            <div class="s_update-vignette"></div>
            @if (sceneUrl) {
               <img class="s_update-scene-image" [src]="sceneUrl" alt="" (error)="onSceneError()">
            }
            @for (m of motes; track $index) {
               <div
                  class="s_update-mote"
                  [style.width.px]="m.sizePx"
                  [style.height.px]="m.sizePx"
                  [style.left.%]="m.leftPct"
                  [style.top.%]="m.topPct"
                  [style.animation-duration.s]="m.durationS"
                  [style.animation-delay.s]="m.delayS"
                  [style.background]="m.background"></div>
            }
            <div class="s_update-overlay">
               <div class="s_update-title">
                  Updating Safari SOP<span class="s_update-dots"><span>.</span><span>.</span><span>.</span></span>
               </div>
               <div class="s_update-progress"><div class="s_update-progress-fill"></div></div>
            </div>
         </div>
      }
   </main>
</div>
